import { Page, PageHeader } from "@dash/page";
import { Pagination } from "@dash/search";
import { QuerySkeleton } from "@dash/skeleton";

import { useClientManager } from "@megaron/react-clients";

import { BlikChecksFilters } from "./BlikChecksFilters";
import { BlikChecksTable } from "./BlikChecksTable";
import { useBlikChecksFilters } from "./useBlikChecksFilters";

export const BlikChecksHome = () => {
  const { filters, setFilter, setFilters } = useBlikChecksFilters();

  const pageSize = 20;
  const page = filters.page ?? 0;
  const offset = page * pageSize;

  const cashRewardsClient = useClientManager("cashRewards");

  const checksQuery = cashRewardsClient.blikChecksQuery().useQuery({
    limit: pageSize,
    offset,
    status: filters.status,
  });

  return (
    <Page css={{ display: "flex", flexDirection: "column", gap: "1rem", maxWidth: "100%" }}>
      <PageHeader>Zarządzanie czekami BLIK</PageHeader>
      <div
        css={{
          display: "flex",
          gap: "1rem",
          marginBottom: "0.5rem",
          flexWrap: "wrap",
          width: "100%",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <BlikChecksFilters
          values={filters}
          onChange={(patch) => {
            setFilters({ ...filters, ...patch, page: 0 });
          }}
        />
        <Pagination
          css={{ maxHeight: "41px", alignSelf: "flex-end" }}
          page={page}
          onPageChange={(p) => {
            setFilter("page")(p);
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          pageSize={pageSize}
          itemCount={checksQuery.data?.count ?? 0}
        />
      </div>
      <QuerySkeleton query={checksQuery}>
        {(checks) => (
          <BlikChecksTable isLoading={false} checks={checks.items} />
        )}
      </QuerySkeleton>
    </Page>
  );
};
